/* eslint-disable */
//@ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTile: null,
  customTile: null,
  tileConfiguration: null,
  selectedGroutColorData: null,
  selectedTileData: null,
  currentNavStep: null,
};

export const tileSlice = createSlice({
  name: 'tile',
  initialState,
  reducers: {
    setSelectedTile: (state, { payload }) => {
      state.selectedTile = payload;
    },
    setCustomTile: (state, { payload }) => {
      state.customTile = payload;
    },
    setTileConfiguration: (state, { payload }) => {
      state.tileConfiguration = payload;
    },
    setGroutColorData: (state, { payload }) => {
      state.selectedGroutColorData = payload;
    },
    setSelectedTileData: (state, { payload }) => {
      state.selectedTileData = payload;
    },
    setCurrentNavStep: (state, { payload }) => {
      state.currentNavStep = payload;
    },
    deleteGroutColorData: (state, { payload }) => {
      state.selectedGroutColorData = payload;
      localStorage.setItem('tile/setGroutColorData', JSON.stringify(payload));
    },
    reset: () => {
      // localStorage.clear();
      return initialState;
    },
  },
});

export const tileSliceCachedActions = [
  // 'tile/setSelectedTile',
  // 'tile/setCustomTile',
  // 'tile/setTileConfiguration',
  // 'tile/setGroutColorData',
  // 'tile/setSelectedTileData',
  'tile/setCurrentNavStep',
];

export const {
  setSelectedTile,
  setCustomTile,
  setTileConfiguration,
  setGroutColorData,
  setSelectedTileData,
  deleteGroutColorData,
  setCurrentNavStep,
  reset,
} = tileSlice.actions;

export const tileReducer = tileSlice.reducer;
